import { Stack } from "@mantine/core";
import { useNavigate, useParams } from "react-router-dom";
import Actions from "src/components/Actions";
import Loader from "src/components/Loader";
import useApi, { useGET } from "src/hooks/useApi";
import ProposalCard from "src/components/cards/Proposal.Card";
import Proposal from "src/types/Proposal.type";
import TrackingSystem from "../../../lib/Tracking/TrackingSystem";

export default function RemoveProposal() {
  const navigate = useNavigate();
  const { id } = useParams();
  const api = useApi();

  const url = `res/proposal/${id}`;
  const { data, isLoading, error } = useGET<Proposal>(url);

  const handleConfirm = () => {
    api.DELETE(`res/proposal/${id}`);
      TrackingSystem.getInstance().sendCustomEvent("peoposal_deleted");

    navigate("/app");
  };
  const handleCancel = () => navigate(-1);

  if (error || (!isLoading && !data)) {
    navigate("/404");
  }
  return (
    <Stack align="center">
      Are you sure to remove this application?
      <Loader isLoading={isLoading} error={error} hasData={!!data}>
        <ProposalCard proposal={data} />
      </Loader>
      <Actions
        actions={[
          {
            label: "cancel",
            onClick: handleCancel,
            variant: "default",
          },
          {
            label: "confirm",
            onClick: handleConfirm,
          },
        ]}
      />
    </Stack>
  );
}
